import { Typography } from "@mui/material";
import { ProductMetaWrapper } from "../styles/product";

export default function ProductName({ product, matches }) {
  return (
    <ProductMetaWrapper>
      <Typography
        textTransform="capitalize"
        variant={matches ? "h6" : "h5"}
        sx={{
          fontSize: matches ? "1.2rem" : "1.4rem",
          fontWeight: 700,
          lineHeight: 1.2,
          margin: 0,
          textAlign: "center",
        }}
      >
        {product.name}
      </Typography>
    </ProductMetaWrapper>
  );
}
